{
  "F11.13": ["Astinenza da oppiacei - con disturbo da uso lieve"],
  "F11.23": ["Astinenza da oppiacei - con disturbo da uso moderato o grave"],
  "F01.50": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Gravità non specificata - Senza alterazione comportamentale o psicologica associata"
  ],
  "F01.511": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Gravità non specificata - Con agitazione"
  ],
  "F01.518": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Gravità non specificata - Con altra alterazione comportamentale o psicologica"
  ],
  "F01.52": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Gravità non specificata - Con alterazione psicotica"
  ],
  "F01.53": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Gravità non specificata - Con sintomi dell'umore"
  ],
  "F01.54": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Gravità non specificata - Con ansia"
  ],
  "F01.A0": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Lieve - Senza alterazione comportamentale o psicologica associata"
  ],
  "F01.A11": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Lieve - Con agitazione"
  ],
  "F01.A18": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Lieve - Con altra alterazione comportamentale o psicologica"
  ],
  "F01.A2": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Lieve - Con alterazione psicotica"
  ],
  "F01.A3": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Lieve - Con sintomi dell'umore"
  ],
  "F01.A4": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Lieve - Con ansia"
  ],
  "F01.B0": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Moderato - Senza alterazione comportamentale o psicologica associata"
  ],
  "F01.B11": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Moderato - Con agitazione"
  ],
  "F01.B18": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Moderato - Con altra alterazione comportamentale o psicologica"
  ],
  "F01.B2": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Moderato - Con alterazione psicotica"
  ],
  "F01.B3": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Moderato - Con sintomi dell'umore"
  ],
  "F01.B4": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Moderato - Con ansia"
  ],
  "F01.C11": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Grave - Con agitazione"
  ],
  "F01.C18": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Grave - Con altra alterazione comportamentale o psicologica"
  ],
  "F01.C2": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Grave - Con alterazione psicotica"
  ],
  "F01.C3": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Grave - Con sintomi dell'umore"
  ],
  "F01.C4": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Grave - Con ansia"
  ],
  "F01.CO": [
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia vascolare - Grave - Senza alterazione comportamentale o psicologica associata"
  ],
  "F02. A18": [
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Lieve - Con altra alterazione comportamentale o psicologica"
  ],
  "F02. C18": [
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Grave - Con altra alterazione comportamentale o psicologica ",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Grave - Con altra alterazione comportamentale o psicologica"
  ],
  "F02.03": [
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Grave - con sintomi dell'umore"
  ],
  "F02.80": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Gravità non specificata - Senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Gravità non specificata - Senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Gravità non specificata - Senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Gravità non specificata - Senza alterazione comportamentale o psicologica associata"
  ],
  "F02.811": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Gravità non specificata - Con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Gravità non specificata - Con agitazione"
  ],
  "F02.818": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Gravità non specificata - Con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Gravità non specificata - Con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Gravità non specificata - Con altra alterazione comportamentale o psicologica"
  ],
  "F02.82": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Gravità non specificata - con agitazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Gravità non specificata - Con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Gravità non specificata - Con alterazione psicotica"
  ],
  "F02.83": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Gravità non specificata - Con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Gravità non specificata - Con sintomi dell'umore"
  ],
  "F02.84": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Gravità non specificata - Con ansia",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Gravità non specificata - Con ansia"
  ],
  "F02.A0": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Lieve - Senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Lieve - Senza alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Lieve - Senza alterazione comportamentale o psicologica associata"
  ],
  "F02.A11": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - lieve - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - lieve - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - lieve - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - lieve - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - lieve - con agitazione",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - lieve - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Lieve - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Lieve - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Lieve - Con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Lieve - Con agitazione"
  ],
  "F02.A18": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Lieve - Con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Lieve - Con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Lieve - Con altra alterazione comportamentale o psicologica"
  ],
  "F02.A2": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Lieve - con agitazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Lieve - Con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Lieve - Con alterazione psicotica"
  ],
  "F02.A3": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Lieve - Con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Lieve - Con sintomi dell'umore"
  ],
  "F02.A4": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - lieve - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - lieve - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - lieve - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - lieve - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - lieve - con ansia",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - lieve - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Lieve - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Lieve - con ansia ",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Lieve - Con ansia",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Lieve - Con ansia"
  ],
  "F02.B0": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Moderato - Senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Moderato - Senza alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Moderato - Con sintomi dell'umore"
  ],
  "F02.B11": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Moderato - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Moderato - Con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Moderato - Con agitazione"
  ],
  "F02.B18": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Moderato - Con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Moderato - Con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Moderato - Con altra alterazione comportamentale o psicologica"
  ],
  "F02.B2": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Moderato - Con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Moderato - Con alterazione psicotica"
  ],
  "F02.B3": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Moderato - Con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Moderato - Con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Moderato - Con sintomi dell'umore"
  ],
  "F02.B4": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - moderato - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - moderato - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - moderato - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - moderato - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - moderato - con ansia",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - moderato - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Moderato - con ansia",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Moderato - Con ansia",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Moderato - Con ansia"
  ],
  "F02.C0": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Grave - Senza alterazione comportamentale o psicologica associata"
  ],
  "F02.C11": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - grave - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - grave - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - grave - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - grave - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - grave - con agitazione",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - grave - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni (codificare prima A81.9 malattia da prioni) - Grave -  con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale (codificare prima G31.09 degenerazione frontotemporale) - Grave - Con agitazione ",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica (codificare prima l'altra condizione medica) - Grave - Con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici (codificare prima le altre eziologie mediche) - Grave - Con agitazione"
  ],
  "F02.C18": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Grave - Con altra alterazione comportamentale o psicologica"
  ],
  "F02.C2": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - grave - con alterazione psicotica",
    "Disturbo neurocogbitivo maggiore probabilmente dovuto a malattia di Parkinson - grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Grave - con agitazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Grave - Con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Grave - Con alterazione psicotica"
  ],
  "F02.C3": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Grave - Con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Grave - Con sintomi dell'umore"
  ],
  "F02.C4": [
    "Disturbo neurocognitivo maggiore a probabili corpi di Lewy - grave - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a danno cerebrale traumatico - grave - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a malattia di Huntington - grave - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a infezione da HIV - grave - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a probabile malattia di Alzheimer - grave - con ansia",
    "Disturbo neurocognitivo maggiore probabilmente dovuto a malattia di Parkinson - grave - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Grave - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Grave - con ansia",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Grave - Con ansia ",
    "Disturbo neurocognitivo maggiore dovuto a eziologie molteplici - Grave - Con ansia"
  ],
  "F02.CO": [
    "Disturbo neurocognitivo maggiore dovuto a malattie da prioni - Grave - Senza alterazione comportamentale o psicologica associata ",
    "Disturbo neurocognitivo maggiore dovuto a probabile degenerazione frontotemporale - Grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto ad altra condizione medica - Grave - Senza alterazione comportamentale o psicologica associata"
  ],
  "F03. A11": [
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Lieve - Con agitazione"
  ],
  "F03.90": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - gravità non specificata - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Gravità non specificata - Senza alterazione comportamentale o psicologica associata"
  ],
  "F03.911": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - gravità non specificata - con agitazione",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Gravità non specificata - Con agitazione"
  ],
  "F03.918": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - gravità non specificata - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Gravità non specificata - Con altra alterazione comportamentale o psicologica"
  ],
  "F03.92": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - gravità non specificata - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Gravità non specificata - Con alterazione psicotica"
  ],
  "F03.93": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - gravità non specificata - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Gravità non specificata - Con sintomi dell'umore"
  ],
  "F03.94": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - gravità non specificata - con ansia",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Gravità non specificata - Con ansia"
  ],
  "F03.A0": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - lieve - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Lieve - Senza alterazione comportamentale o psicologica associata"
  ],
  "F03.A11": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - lieve - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - lieve - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - lieve - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - lieve - con agitazione",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - lieve - con agitazione"
  ],
  "F03.A18": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - lieve - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Lieve - Con altra alterazione comportamentale o psicologica"
  ],
  "F03.A2": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - lieve - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Lieve - Con alterazione psicotica"
  ],
  "F03.A3": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - lieve - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Lieve - Con sintomi dell'umore"
  ],
  "F03.A4": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - lieve - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - lieve - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - lieve - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - lieve - con ansia",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - lieve - con ansia",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Lieve - Con ansia"
  ],
  "F03.B0": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - moderato - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Moderato - Senza alterazione comportamentale o psicologica associata"
  ],
  "F03.B11": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - moderato - con agitazione",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Moderato - Con agitazione"
  ],
  "F03.B18": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - moderato - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Moderato - Con altra alterazione comportamentale o psicologica"
  ],
  "F03.B2": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - moderato - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Moderato - Con alterazione psicotica"
  ],
  "F03.B3": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - moderato - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Moderato - Con sintomi dell'umore"
  ],
  "F03.B4": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - moderato - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - moderato - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - moderato - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - moderato - con ansia",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - moderato - con ansia",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Moderato - Con ansia"
  ],
  "F03.C0": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - grave - senza alterazione comportamentale o psicologica associata",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - grave - senza alterazione comportamentale o psicologica associata"
  ],
  "F03.C11": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - grave - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - grave - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - grave - con agitazione",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - grave - con agitazione",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - grave - con agitazione",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Grave - Con agitazione"
  ],
  "F03.C18": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - grave - con altra alterazione comportamentale o psicologica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Grave - Con altra alterazione comportamentale o psicologica"
  ],
  "F03.C2": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - grave - con alterazione psicotica",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Grave - Con alterazione psicotica"
  ],
  "F03.C3": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - grave - con sintomi dell'umore",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Grave - Con sintomi dell'umore"
  ],
  "F03.C4": [
    "Disturbo neurocognitivo maggiore a possibili corpi di Lewy - grave - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a eziologia sconosciuta - grave - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a possibile degenerazione frontotemporale - grave - con ansia",
    "Disturbo neurocognitivo maggiore dovuto a possibile malattia di Alzheimer - grave - con ansia",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia vascolare - grave - con ansia",
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Grave - Con ansia"
  ],
  "F03.CO": [
    "Disturbo neurocognitivo maggiore possibilmente dovuto a malattia di Parkinson - Grave - Senza alterazione comportamentale o psicologica associata"
  ],
  "F06.0": [
    "Disturbo psicotico dovuto ad altra condizione medica - con allucinazioni"
  ],
  "F06.1": [
    "Catatonia associata ad un altro disturbo mentale (specificatore della catatonia)",
    "Disturbo catatonico dovuto ad altra condizione medica"
  ],
  "F06.2": [
    "Disturbo psicotico dovuto ad altra condizione medica - con deliri"
  ],
  "F06.31": [
    "Disturbo depressivo dovuto ad altra condizione medica - con caratteristiche depressive"
  ],
  "F06.32": [
    "Disturbo depressivo dovuto ad altra condizione medica - con episodio simil-depressivo maggiore"
  ],
  "F06.33": [
    "Disturbo bipolare e disturbi correlati dovuti ad altra condizione medica - con caratteristiche maniacali",
    "Disturbo bipolare e disturbi correlati dovuti ad altra condizione medica - con episodio simil-maniacale o simil-ipomaniacale"
  ],
  "F06.34": [
    "Disturbo bipolare e disturbi correlati dovuti ad altra condizione medica - con caratteristiche miste",
    "Disturbo depressivo dovuto ad altra condizione medica - con caratteristiche miste"
  ],
  "F06.4": ["Disturbo d'ansia dovuto ad altra cobnsizione medica"],
  "F06.70": [
    "Disturbo neurocognitivo lieve a probabili corpi di Lewy - senza alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto ad altra condizione medica - senza alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto a danno cerebrale traumatico - senza alterazione comportamentale",
    "Disturbo enurocognitivo lieve dovuto a eziologie molteplici - senza alterazione comportamentale",
    "Disturbo enurocognitivo lieve dovuto a infezione da HIV - senza alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto a malattia di Huntington - senza alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto a malattie da prioni - senza alterazione comportamentale",
    "Disturbo neurocognitivo lieve probabilmente dovuto a malattia vascolare - senza alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto a robabile degenerazione frontotemporale -senza alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto a probabile malattia di Alzheimer - senza alterazione comportamentale",
    "Disturbo neurocognitivo lieve probabilmente dovuto a malattia di Parkinson - senza alterazione comportamentale"
  ],
  "F06.71": [
    "Disturbo neurocognitivo lieve a probabili corpi di Lewy - con alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto ad altra condizione medica - con alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto a danno cerebrale traumatico - con alterazione comportamentale",
    "Disturbo enurocognitivo lieve dovuto a eziologie molteplici - con alterazione comportamentale",
    "Disturbo enurocognitivo lieve dovuto a infezione da HIV - con alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto a malattia di Huntington - con alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto a malattie da prioni - con alterazione comportamentale",
    "Disturbo neurocognitivo lieve probabilmente dovuto a malattia vascolare - con alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto a robabile degenerazione frontotemporale - Con alterazione comportamentale",
    "Disturbo neurocognitivo lieve dovuto a probabile malattia di Alzheimer - con alterazione comportamentale",
    "Disturbo neurocognitivo lieve probabilmente dovuto a malattia di Parkinson - con alterazione comportamentale"
  ],
  "F06.8": [
    "Disturbo mentale dovuto ad altra condizione medica",
    "Disturbo ossessivo-compulsivo e disturbi correlati dovuti ad altra condizione medica"
  ],
  "F09": [
    "Disturbo mentale dovuto ad altra condizione medica senza specificazione"
  ],
  "F10.10": ["Disturbo da uso da alcol - lieve"],
  "F10.11": [
    "Disturbo da uso da alcol - lieve - in remissione precoce",
    "Disturbo da uso da alcol - lieve - in remissione protratta"
  ],
  "F10.130": [
    "Astinenza da alcol - senza alterazioni percettive - con disturbo da uso lieve"
  ],
  "F10.132": [
    "Astinenza da alcol - con alterazioni percettive - con disturbo da uso lieve"
  ],
  "F10.14": [
    "Disturbo bipolare e disturbi correlati indotti da alcol - con disturbo da uso lieve",
    "Disturbo depressivo indotto da alcol - con disturbo da uso lieve"
  ],
  "F10.159": [
    "Disturbo psicotico indotto da alcol - con disturbo da uso lieve"
  ],
  "F10.180": ["Disturbo d'ansia indotto da alcol - con disturbo da uso lieve"],
  "F10.181": [
    "Disfunzione sessuale indotta da alcol - con disturbo da uso lieve"
  ],
  "F10.188": [
    "Disturbo neurocognitivo lieve indotto da alcol - con disturbo da uso lieve"
  ],
  "F10.20": [
    "Disturbo da uso da alcol - grave",
    "Disturbo da uso da alcol - moderato"
  ],
  "F10.21": [
    "Disturbo da uso da alcol - grave - in remissione precoce",
    "Disturbo da uso da alcol - grave - in remissione protratta",
    "Disturbo da uso da alcol - moderato - in remissione precoce",
    "Disturbo da uso da alcol - moderato - in remissione protratta"
  ],
  "F10.230": [
    "Astinenza da alcol - senza alterazioni percettive - con disturbo da uso moderato o grave"
  ],
  "F10.232": [
    "Astinenza da alcol - con alterazioni percettive - con disturbo da uso moderato o grave"
  ],
  "F10.24": [
    "Disturbo bipolare e disturbi correlati indotti da alcol - con disturbo da uso moderato o grave",
    "Disturbo depressivo indotto da alcol - con disturbo da uso moderato o grave"
  ],
  "F10.259": [
    "Disturbo psicotico indotto da alcol - con disturbo da uso moderato o grave"
  ],
  "F10.26": [
    "Disturbo neurocognitivo maggiore indotto da alcol - tipo amnesico confabulatorio - con disturbo da uso moderato o grave"
  ],
  "F10.27": [
    "Disturbo neurocognitivo maggiore indotto da alcol - tipo non amnesico confabulatorio - con disturbo da uso moderato o grave"
  ],
  "F10.280": [
    "Disturbo d'ansia indotto da alcol - con disturbo da uso moderato o grave"
  ],
  "F10.281": [
    "Disfunzione sessuale indotta da alcol -  con disturbo da uso moderato o grave"
  ],
  "F10.288": [
    "Disturbo neurocognitivo lieve indotto da alcol - con disturbo da uso moderato o grave"
  ],
  "F10.930": ["Astinenza da alcol - senza disturbo da uso"],
  "F10.932": [
    "Astinenza da alcol - con alterazioni percettive - senza disturbo da uso"
  ],
  "F10.94": [
    "Disturbo bipolare e disturbi correlati indotti da alcol - senza disturbo da uso",
    "Disturbo depressivo indotto da alcol - senza disturbo da uso"
  ],
  "F10.959": ["Disturbo psicotico indotto da alcol - senza disturbo da uso"],
  "F10.96": [
    "Disturbo neurocognitivo maggiore indotto da alcol - tipo amnesico confabulatorio - senza disturbo da uso"
  ],
  "F10.97": [
    "Disturbo neurocognitivo maggiore indotto da alcol - tipo non amnesico confabulatorio - senza disturbo da uso"
  ],
  "F10.980": ["Disturbo d'ansia indotto da alcol - senza disturbo da uso"],
  "F10.981": ["Disfunzione sessuale indotta da alcol - senza disturbo da uso"],
  "F10.988": [
    "Disturbo neurocognitivo lieve indotto da alcol - senza disturbo da uso"
  ],
  "F10.99": ["Disturbo correlato all'alcol senza specificazione"],
  "F11.10": ["Disturbo da uso di oppiacei - lieve"],
  "F11.11": [
    "Disturbo da uso di oppiacei - lieve - in remissione precoce",
    "Disturbo da uso di oppiacei - lieve - in remissione protratta"
  ],
  "F11.14": [
    "Disturbo depressivo indotto da oppiacei - con disturbo da uso lieve"
  ],
  "F11.181": [
    "Disfunzione sessuale indotta da oppiacei - con disturbo da uso lieve"
  ],
  "F11.188": [
    "Disturbo d'ansia indotto da oppiacei - con disturbo da uso lieve"
  ],
  "F11.20": [
    "Disturbo da uso di oppiacei - grave",
    "Disturbo da uso di oppiacei - moderata"
  ],
  "F11.21": [
    "Disturbo da uso di oppiacei - grave - in remissione precoce",
    "Disturbo da uso di oppiacei - grave - in remissione protratta",
    "Disturbo da uso di oppiacei - moderata - in remissione precoce",
    "Disturbo da uso di oppiacei - moderata - in remissione protratta"
  ],
  "F11.24": [
    "Disturbo depressivo indotto da oppiacei - con disturbo da uso moderato o grave"
  ],
  "F11.281": [
    "Disfunzione sessuale indotta da oppiacei - con disturbo da uso moderato o grave"
  ],
  "F11.288": [
    "Disturbo d'ansia indotto da oppiacei - con disturbo da uso moderato"
  ],
  "F11.94": ["Disturbo depressivo indotto da oppiacei - senza disturbo da uso"],
  "F11.981": [
    "Disfunzione sessuale indotta da oppiacei - senza disturbo da uso"
  ],
  "F11.988": ["Disturbo d'ansia indotto da oppiacei - senza disturbo da uso"],
  "F11.99": ["Disturbo correlato agli oppiacei senza specificazione"],
  "F12.10": ["Disturbo da uso di cannabis - Lieve"],
  "F12.11": [
    "Disturbo da uso di cannabis - Lieve - in remissione precoce",
    "Disturbo da uso di cannabis - Lieve - in remissione protratta"
  ],
  "F12.13": ["Astinenza da cannabis - con disturbo da uso lieve"],
  "F12.159": [
    "Disturbo psicotico indotto da cannabis - Con disturbo da uso lieve"
  ],
  "F12.180": [
    "Disturbo d'ansia indotto da cannabis - con disturbo da uso lieve"
  ],
  "F12.20": [
    "Disturbo da uso di cannabis - Grave",
    "Disturbo da uso di cannabis - Moderato "
  ],
  "F12.21": [
    "Disturbo da uso di cannabis - Grave - in remissione precoce",
    "Disturbo da uso di cannabis - Grave - in remissione protratta",
    "Disturbo da uso di cannabis - Moderato - in remissione precoce",
    "Disturbo da uso di cannabis - Moderato - in remissione protratta"
  ],
  "F12.23": ["Astinenza da cannabis - con disturbo da uso moderato o grave"],
  "F12.259": [
    "Disturbo psicotico indotto da cannabis - Con disturbo da uso moderato o grave "
  ],
  "F12.280": [
    "Disturbo d'ansia indotto da cannabis - con disturbo da uso moderato"
  ],
  "F12.93": ["Astinenza da cannabis - senza disturbo da uso"],
  "F12.959": ["Disturbo psicotico indotto da cannabis - Senza disturbo da uso"],
  "F12.980": ["Disturbo d'ansia indotto da cannabis - senza disturbo da uso"],
  "F12.99": ["Disturbo correlato alla cannabis senza specificazione"],
  "F13.10": ["Disturbo da uso di sedativi, ipnotici o ansiolitici - lieve"],
  "F13.11": [
    "Disturbo da uso di sedativi, ipnotici o ansiolitici - lieve - in remissione precoce",
    "Disturbo da uso di sedativi, ipnotici o ansiolitici - lieve - in remissione protratta"
  ],
  "F13.130": [
    "Astinenza da sedativi, ipnotici o ansiolitici - senza alterazioni percettive - con disturbo da uso lieve"
  ],
  "F13.132": [
    "Astinenza da sedativi, ipnotici o ansiolitici - con alterazioni percettive - con disturbo da uso lieve"
  ],
  "F13.14": [
    "Disturbo bipolare e disturbi correlati indotti da sedativi, ipnotici o ansiolitici - con disturbo da uso lieve",
    "Disturbo depressivo indotto da sedativi, ipnotici o ansiolitici - con disturbo da uso lieve"
  ],
  "F13.159": [
    "Disturbo psicotico indotto da sedativi, ipnotici o ansiolitici - Con disturbo da uso lieve"
  ],
  "F13.180": [
    "Disturbo d'ansia indotto da sedativi, ipnotici o ansiolitici - con disturbo da uso lieve"
  ],
  "F13.181": [
    "Disfunzione sessuale indotta da sedativi, ipnotici o ansiolitici - con disturbo da uso lieve"
  ],
  "F13.188": [
    "Disturbo neurocognitivo lieve indotto da sedativi, ipnotici o ansiolitici - con disturbo da uso lieve"
  ],
  "F13.20": [
    "Disturbo da uso di sedativi, ipnotici o ansiolitici - grave",
    "Disturbo da uso di sedativi, ipnotici o ansiolitici - moderato"
  ],
  "F13.21": [
    "Disturbo da uso di sedativi, ipnotici o ansiolitici - grave - in remissione precoce",
    "Disturbo da uso di sedativi, ipnotici o ansiolitici - grave - in remissione protratta",
    "Disturbo da uso di sedativi, ipnotici o ansiolitici - moderato - in remissione precoce",
    "Disturbo da uso di sedativi, ipnotici o ansiolitici - moderato - in remissione protratta"
  ],
  "F13.230": [
    "Astinenza da sedativi, ipnotici o ansiolitici - senza alterazioni percettive - con disturbo da uso moderato o grave"
  ],
  "F13.232": [
    "Astinenza da sedativi, ipnotici o ansiolitici - con alterazioni percettive - con disturbo da uso moderato o grave"
  ],
  "F13.24": [
    "Disturbo bipolare e disturbi correlati indotti da sedativi, ipnotici o ansiolitici - con disturbo da uso moderato o grave",
    "Disturbo depressivo indotto da sedativi, ipnotici o ansiolitici - con disturbo da uso moderato o grave"
  ],
  "F13.259": [
    "Disturbo psicotico indotto da sedativi, ipnotici o ansiolitici - ipnotici o ansiolitici, Con disturbo da uso moderato o grave"
  ],
  "F13.27": [
    "Disturbo neurocognitivo maggiore indotto da sedativi, ipnotici o ansiolitici - Con disturbo da uso moderato o grave"
  ],
  "F13.280": [
    "Disturbo d'ansia indotto da sedativi, ipnotici o ansiolitici - con disturbo da uso moderato"
  ],
  "F13.281": [
    "Disfunzione sessuale indotta da sedativi, ipnotici o ansiolitici - con disturbo da uso moderato o grave"
  ],
  "F13.288": [
    "Disturbo neurocognitivo lieve indotto da sedativi, ipnotici o ansiolitici - con disturbo da uso moderato o grave"
  ],
  "F13.930": [
    "Astinenza da sedativi, ipnotici o ansiolitici - senza alterazioni percettive - senza disturbo da uso"
  ],
  "F13.932": [
    "Astinenza da sedativi, ipnotici o ansiolitici - con alterazioni percettive - senza disturbo da uso"
  ],
  "F13.94": [
    "Disturbo bipolare e disturbi correlati indotti da sedativi, ipnotici o ansiolitici - senza disturbo da uso",
    "Disturbo depressivo indotto da sedativi, ipnotici o ansiolitici - senza disturbo da uso"
  ],
  "F13.959": [
    "Disturbo psicotico indotto da sedativi, ipnotici o ansiolitici - ipnotici o ansiolitici, Senza disturbo da uso"
  ],
  "F13.97": [
    "Disturbo neurocognitivo maggiore indotto da sedativi, ipnotici o ansiolitici - Senza disturbo da uso"
  ],
  "F13.980": [
    "Disturbo d'ansia indotto da sedativi, ipnotici o ansiolitici - senza disturbo da uso "
  ],
  "F13.981": [
    "Disfunzione sessuale indotta da sedativi, ipnotici o ansiolitici - senza disturbo da uso"
  ],
  "F13.988": [
    "Disturbo neurocognitivo lieve indotto da sedativi, ipnotici o ansiolitici - senza disturbo da uso"
  ],
  "F13.99": [
    "Disturbo correlato a sedativi, ipnotici o ansiolitici senza specificazione"
  ],
  "F14.10": ["Disturbo da uso di cocaina - Lieve"],
  "F14.11": [
    "Disturbo da uso di cocaina - Lieve - in remissione precoce",
    "Disturbo da uso di cocaina - Lieve - in remissione protratta"
  ],
  "F14.13": ["Astinenza da cocaina - con disturbo da uso lieve"],
  "F14.14": [
    "Disturbo bipolare e disturbi correlati indotti da cocaina - con disturbo da uso lieve",
    "Disturbo depressivo indotto da cocaina - con disturbo da uso lieve"
  ],
  "F14.159": [
    "Disturbo psicotico indotto da cocaina - Con disturbo da uso lieve"
  ],
  "F14.180": [
    "Disturbo d'ansia indotto da cocaina - con disturbo da uso lieve"
  ],
  "F14.181": [
    "Disfunzione sessuale indotta da cocaina - con disturbo da uso lieve"
  ],
  "F14.188": [
    "Disturbo ossessivo-compulsivo e disturbi correlati indotti da cocaina - con disturbo da uso lieve",
    "Disturbo neurocognitivo lieve indotto da cocaina - con disturbo da uso lieve"
  ],
  "F14.20": [
    "Disturbo da uso di cocaina - Grave",
    "Disturbo da uso di cocaina - Moderato"
  ],
  "F14.21": [
    "Disturbo da uso di cocaina - Grave - in remissione precoce",
    "Disturbo da uso di cocaina - Grave - in remissione protratta",
    "Disturbo da uso di cocaina - Moderato - in remissione precoce",
    "Disturbo da uso di cocaina - Moderato -  in remissione protratta"
  ],
  "F14.23": ["Astinenza da cocaina - con disturbo da uso moderato o grave"],
  "F14.24": [
    "Disturbo bipolare e disturbi correlati indotti da cocaina - con disturbo da uso moderato o grave",
    "Disturbo depressivo indotto da cocaina - con disturbo da uso moderato o grave"
  ],
  "F14.259": [
    "Disturbo psicotico indotto da cocaina - Con disturbo da uso moderato o grave"
  ],
  "F14.280": [
    "Disturbo d'ansia indotto da cocaina - con disturbo da uso moderato"
  ],
  "F14.281": [
    "Disfunzione sessuale indotta da cocaina - con disturbo da uso moderato o grave"
  ],
  "F14.288": [
    "Disturbo ossessivo-compulsivo e disturbi correlati indotti da cocaina - con disturbo da uso moderato o grave",
    "Disturbo neurocognitivo lieve indotto da cocaina - con disturbo da uso moderato o grave"
  ],
  "F14.93": ["Astinenza da cocaina - senza disturbo da uso"],
  "F14.94": [
    "Disturbo bipolare e disturbi correlati indotti da cocaina - senza disturbo da uso",
    "Disturbo depressivo indotto da cocaina - senza disturbo da uso"
  ],
  "F14.959": ["Disturbo psicotico indotto da cocaina - Senza disturbo da uso"],
  "F14.980": ["Disturbo d'ansia indotto da cocaina - senza disturbo da uso"],
  "F14.981": [
    "Disfunzione sessuale indotta da cocaina - senza disturbo da uso"
  ],
  "F14.988": [
    "Disturbo ossessivo-compulsivo e disturbi correlati indotti da cocaina - senza disturbo da uso",
    "Disturbo neurocognitivo lieve indotto da cocaina - senza disturbo da uso"
  ],
  "F14.99": ["Disturbo correlato alla cocaina senza specificazione"],
  "F15.10": [
    "Disturbo da sostanze anfetaminosimili - lieve",
    "Disturbo da uso di stimolanti altri o non specificati - lieve"
  ],
  "F15.11": [
    "Disturbo da sostanze anfetaminosimili - lieve - in remissione precoce",
    "Disturbo da sostanze anfetaminosimili - lieve - in remissione protratta",
    "Disturbo da uso di stimolanti altri o non specificati - lieve - in remissione precoce",
    "Disturbo da uso di stimolanti altri o non specificati - lieve - in remissione protratta"
  ],
  "F15.13": [
    "Astinenza da sostanze anfetamonosimili - con disturbo da uso lieve",
    "Astinenza da altro stimolante - con disturbo da uso lieve"
  ],
  "F15.14": [
    "Disturbo depressivo indotto da sostanze amfetaminosimili o altri stimolanti - con disturbo da uso lieve"
  ],
  "F15.159": [
    "Disturbo psicotico indotto da sostanze amfetaminosimili o altri stimolanti - Con disturbo da uso lieve"
  ],
  "F15.180": [
    "Disturbo d'ansia indotto da sostanze amfetaminosimili o altri stimolanti- con disturbo da uso lieve"
  ],
  "F15.181": [
    "Disfunzione sessuale indotta da sostanze amfetaminosimili o altri stimolanti - con disturbo da uso lieve"
  ],
  "F15.188": [
    "Disturbo ossessivo-compulsivo e disturbi correlati indotti da sostanze anfetaminosimili o altri stimolanti - con disturbo da uso lieve",
    "Disturbo neurocognitivo lieve indotto da sostanze amfetaminosimili o altri stimolanti - con disturbo da uso lieve"
  ],
  "F15.20": [
    "Disturbo da sostanze anfetaminosimili - grave",
    "Disturbo da sostanze anfetaminosimili - moderato",
    "Disturbo da uso di altri o non specificati stimolanti - Grave",
    "Disturbo da uso di altri o non specificati stimolanti - Moderato"
  ],
  "F15.21": [
    "Disturbo da sostanze anfetaminosimili - grave - in remissione precoce",
    "Disturbo da sostanze anfetaminosimili - grave - in remissione protratta",
    "Disturbo da sostanze anfetaminosimili - moderato - in remissione precoce",
    "Disturbo da sostanze anfetaminosimili - moderato - in remissione protratta",
    "Disturbo da uso di altri o non specificati stimolanti - Grave - in remissione precoce",
    "Disturbo da uso di altri o non specificati stimolanti - Grave - in remissione protratta",
    "Disturbo da uso di altri o non specificati stimolanti - Moderato - in remissione precoce",
    "Disturbo da uso di altri o non specificati stimolanti - Moderato - in remissione protratta"
  ],
  "F15.23": [
    "Astinenza da sostanze anfetamonosimili - con disturbo da uso moderato o grave",
    "Astinenza da altro stimolante - con disturbo da uso moderato o grave"
  ],
  "F15.24": [
    "Disturbo depressivo indotto da sostanze amfetaminosimili o altri stimolanti - con disturbo da uso moderato o grave"
  ],
  "F15.259": [
    "Disturbo psicotico indotto da sostanze amfetaminosimili o altri stimolanti - Con disturbo da uso moderato o grave"
  ],
  "F15.280": [
    "Disturbo d'ansia indotto da sostanze amfetaminosimili o altri stimolanti - con disturbo da uso moderato"
  ],
  "F15.281": [
    "Disfunzione sessuale indotta da sostanze amfetaminosimili o altri stimolanti - con disturbo da uso moderato o grave"
  ],
  "F15.288": [
    "Disturbo ossessivo-compulsivo e disturbi correlati indotti da sostanze anfetaminosimili o altri stimolanti - con disturbo da uso moderato o grave",
    "Disturbo neurocognitivo lieve indotto da sostanze amfetaminosimili o altri stimolanti - con disturbo da uso moderato o grave"
  ],
  "F15.93": [
    "Astinenza da sostanze anfetamonosimili - senza disturbo da uso",
    "Astinenza da altro stimolante - senza disturbo da uso",
    "Astinenza da caffeina"
  ],
  "F15.94": [
    "Disturbo depressivo indotto da sostanze amfetaminosimili o altri stimolanti - senza disturbo da uso"
  ],
  "F15.959": [
    "Disturbo psicotico indotto da sostanze amfetaminosimili o altri stimolanti - Senza disturbo da uso"
  ],
  "F15.980": [
    "Disturbo d'ansia indotto da caffeina, Senza disturbo da uso",
    "Disturbo d'ansia indotto da sostanze amfetaminosimili o altri stimolanti - senza disturbo da uso"
  ],
  "F15.981": [
    "Disfunzione sessuale indotta da sostanze amfetaminosimili o altri stimolanti - senza disturbo da uso"
  ],
  "F15.988": [
    "Disturbo ossessivo-compulsivo e disturbi correlati indotti da sostanze anfetaminosimili o altri stimolanti - senza disturbo da uso",
    "Disturbo neurocognitivo lieve indotto da sostanze amfetaminosimili o altri stimolanti - senza disturbo da uso"
  ],
  "F15.99": [
    "Disturbo correlato alla caffeina senza specificazione",
    "Disturbo correlato a sostanze amfetaminosimili senza specificazione"
  ],
  "F16.10": [
    "Disturbo da uso di altri allucinogeni - lieve",
    "Disturbo da uso di fenciclidina - Lieve "
  ],
  "F16.11": [
    "Disturbo da uso di altri allucinogeni - lieve - in remissione precoce",
    "Disturbo da uso di altri allucinogeni - lieve - in remissione protratta",
    "Disturbo da uso di fenciclidina - Lieve - in remissione precoce",
    "Disturbo da uso di fenciclidina - Lieve - in remissione protratta"
  ],
  "F16.14": [
    "Disturbo bipolare e disturbi correlati indotti da altri allucinogeni - con disturbo da uso lieve",
    "Disturbo bipolare e disturbi correlati indotti da fenciclidina - con disturbo da uso lieve",
    "Disturbo depressivo indotto da altri allucinogeni - con disturbo da uso lieve",
    "Disturbo depressivo indotto da fenciclidina - con disturbo da uso lieve"
  ],
  "F16.159": [
    "Disturbo psicotico indotto da altri allucinogeni - Con disturbo da uso lieve",
    "Disturbo psicotico indotto da fenciclidina - Con disturbo da uso lieve"
  ],
  "F16.180": [
    "Disturbo d'ansia indotto da altri allucinogeni - con disturbo da uso lieve",
    "Disturbo d'ansia indotto da fenciclidina - con disturbo da uso lieve"
  ],
  "F16.20": [
    "Disturbo da uso di altri allucinogeni - grave",
    "Disturbo da uso di altri allucinogeni - moderato",
    "Disturbo da uso di fenciclidina - Grave",
    "Disturbo da uso di fenciclidina - Moderato "
  ],
  "F16.21": [
    "Disturbo da uso di altri allucinogeni - grave - in remissione precoce",
    "Disturbo da uso di altri allucinogeni - grave - in remissione protratta",
    "Disturbo da uso di altri allucinogeni - moderato - in remissione precoce",
    "Disturbo da uso di altri allucinogeni - moderato - in remissione protratta",
    "Disturbo da uso di fenciclidina - Grave - in remissione precoce",
    "Disturbo da uso di fenciclidina - Grave -  in remissione protratta",
    "Disturbo da uso di fenciclidina - Moderato - in remissione precoce",
    "Disturbo da uso di fenciclidina - Moderato - in remissione protratta"
  ],
  "F16.24": [
    "Disturbo bipolare e disturbi correlati indotti da altri allucinogeni - con disturbo da uso moderato o grave",
    "Disturbo bipolare e disturbi correlati indotti da fenciclidina - con disturbo da uso moderato o grave",
    "Disturbo depressivo indotto da altri allucinogeni - con disturbo da uso moderato o grave",
    "Disturbo depressivo indotto da fenciclidina - con disturbo da uso moderato o grave"
  ],
  "F16.259": [
    "Disturbo psicotico indotto da altri allucinogeni - Con disturbo da uso moderato o grave",
    "Disturbo psicotico indotto da fenciclidina - Con disturbo da uso moderato o grave"
  ],
  "F16.280": [
    "Disturbo d'ansia indotto da altri allucinogeni - con disturbo da uso moderato o grave",
    "Disturbo d'ansia indotto da fenciclidina - con disturbo da uso moderato"
  ],
  "F16.94": [
    "Disturbo bipolare e disturbi correlati indotti da altri allucinogeni - senza disturbo da uso",
    "Disturbo bipolare e disturbi correlati indotti da fenciclidina - senza disturbo da uso",
    "Disturbo depressivo indotto da altri allucinogeni - senza disturbo da uso",
    "Disturbo depressivo indotto da fenciclidina - senza disturbo da uso"
  ],
  "F16.959": [
    "Disturbo psicotico indotto da altri allucinogeni - Senza disturbo da uso",
    "Disturbo psicotico indotto da fenciclidina - Senza disturbo da uso"
  ],
  "F16.980": [
    "Disturbo d'ansia indotto da altri allucinogeni - senza disturbo da uso",
    "Disturbo d'ansia indotto da fenciclidina - senza disturbo da uso"
  ],
  "F16.983": ["Disturbo percettivo persistente da allucinogeni"],
  "F16.99": [
    "Disturbo correlato agli allucinogeni senza specificazione",
    "Disturbo correlato alla fenciclidina senza specificazione"
  ],
  "F17.200": [
    "Disturbo da uso di tabacco - grave",
    "Disturbo da uso di tabacco - moderato"
  ],
  "F17.201": [
    "Disturbo da uso di tabacco - grave - in remissione precoce",
    "Disturbo da uso di tabacco - grave - in remissione protratta",
    "Disturbo da uso di tabacco - moderato - in remissione precoce",
    "Disturbo da uso di tabacco - moderato - in remissione protratta"
  ],
  "F17.203": ["Astinenza da tabacco"],
  "F17.209": ["Disturbo correlato al tabacco senza specificazione"],
  "F18.10": ["Disturbo da uso di inalanti - Lieve"],
  "F18.11": [
    "Disturbo da uso di inalanti - Lieve - in remissione precoce",
    "Disturbo da uso di inalanti - Lieve - in remissione protratta"
  ],
  "F18.14": [
    "Disturbo depressivo indotto da inalanti - con disturbo da uso lieve"
  ],
  "F18.159": [
    "Disturbo psicotico indotto da inalanti - Con disturbo da uso lieve"
  ],
  "F18.17": [
    "Disturbo neurocognitivo maggiore indotto da inalanti - con disturbi da uso lieve "
  ],
  "F18.180": [
    "Disturbo d'ansia indotto da inalanti - con disturbo da uso lieve"
  ],
  "F18.188": [
    "Disturbo neurocognitivo lieve indotto da inalanti - con disturbo da uso lieve"
  ],
  "F18.20": [
    "Disturbo da uso di inalanti - Grave",
    "Disturbo da uso di inalanti - Moderato"
  ],
  "F18.21": [
    "Disturbo da uso di inalanti - Grave - in remissione precoce",
    "Disturbo da uso di inalanti - Grave - in remissione protratta",
    "Disturbo da uso di inalanti - Moderato - in remissione precoce",
    "Disturbo da uso di inalanti - Moderato - in remissione protratta"
  ],
  "F18.24": [
    "Disturbo depressivo indotto da inalanti - con disturbo da uso moderato o grave"
  ],
  "F18.259": [
    "Disturbo psicotico indotto da inalanti - Con disturbo da uso moderato o grave"
  ],
  "F18.27": [
    "Disturbo neurocognitivo maggiore indotto da inalanti - Con disturbo da uso moderato o grave"
  ],
  "F18.280": [
    "Disturbo d'ansia indotto da inalanti - con disturbo da uso moderato"
  ],
  "F18.288": [
    "Disturbo neurocognitivo lieve indotto da inalanti - con disturbo da uso moderato o grave"
  ],
  "F18.94": ["Disturbo depressivo indotto da inalanti - senza disturbo da uso"],
  "F18.959": ["Disturbo psicotico indotto da inalanti - Senza disturbo da uso"],
  "F18.97": [
    "Disturbo neurocognitivo maggiore indotto da inalanti - Senza disturbo da uso"
  ],
  "F18.980": ["Disturbo d'ansia indotto da inalanti - senza disturbo da uso"],
  "F18.988": [
    "Disturbo neurocognitivo lieve indotto da inalanti - senza disturbo da uso"
  ],
  "F18.99": ["Disturbo correlato agli inalanti senza specificazione"],
  "F19.10": ["Disturbo da uso di altra (o sconosciuta) sostanza - lieve"],
  "F19.11": [
    "Disturbo da uso di altra (o sconosciuta) sostanza - lieve - in remissione precoce",
    "Disturbo da uso di altra (o sconosciuta) sostanza - lieve - in remissione protratta"
  ],
  "F19.130": [
    "Astinenza da altra (o sconosciuta) sostanza - senza alterazioni percettive - con disturbo da uso lieve"
  ],
  "F19.132": [
    "Astinenza da altra (o sconosciuta) sostanza - con alterazioni percettive - con disturbo da uso lieve"
  ],
  "F19.14": [
    "Disturbo bipolare e disturbi correlati indotti da altra (o sconosciuta) sostanza - con disturbo da uso lieve",
    "Disturbo depressivo indotto da altra (o sconosciuta) sostanza - con disturbo da uso lieve"
  ],
  "F19.159": [
    "Disturbo psicotico indotto da altra (o sconosciuta) sostanza - con disturbo da uso lieve"
  ],
  "F19.17": [
    "Disturbo neurocognitivo maggiore indotto da altra (o sconosciuta) sostanza - con disturbo da uso lieve"
  ],
  "F19.180": [
    "Disturbo d'ansia indotto da altra (o sconosciuta) sostanza - con disturbo da uso lieve"
  ],
  "F19.181": [
    "Disfunzione sessuale indotta da altra (o sconosciuta) sostanza - con disturbo da uso lieve "
  ],
  "F19.188": [
    "Disturbo ossessivo-compulsivo e disturbi correlati indotti da altra (o sconosciuta) sostanza - con disturbo da uso lieve",
    "Disturbo neurocognitivo lieve indotto da altra (o sconosciuta) sostanza - con disturbo da uso lieve"
  ],
  "F19.20": [
    "Disturbo da uso di altra (o sconosciuta) sostanza - grave",
    "Disturbo da uso di altra (o sconosciuta) sostanza - moderato"
  ],
  "F19.21": [
    "Disturbo da uso di altra (o sconosciuta) sostanza - grave - in remissione precoce",
    "Disturbo da uso di altra (o sconosciuta) sostanza - grave - in remissione protratta",
    "Disturbo da uso di altra (o sconosciuta) sostanza - moderato - in remissione precoce",
    "Disturbo da uso di altra (o sconosciuta) sostanza - moderato - in remissione protratta"
  ],
  "F19.230": [
    "Astinenza da altra (o sconosciuta) sostanza - senza alterazioni percettive - con disturbo da uso moderato o grave"
  ],
  "F19.232": [
    "Astinenza da altra (o sconosciuta) sostanza - con alterazioni percettive - con disturbo da uso moderato o grave"
  ],
  "F19.24": [
    "Disturbo bipolare e disturbi correlati indotti da altra (o sconosciuta) sostanza - con disturbo da uso moderato o grave",
    "Disturbo depressivo indotto da altra (o sconosciuta) sostanza - con disturbo da uso moderato o grave"
  ],
  "F19.259": [
    "Disturbo psicotico indotto da altra (o sconosciuta) sostanza - con disturbo da uso moderato o grave"
  ],
  "F19.27": [
    "Disturbo neurocognitivo maggiore indotto da altra (o sconosciuta) sostanza - con disturbo da uso moderato o grave"
  ],
  "F19.280": [
    "Disturbo d'ansia indotto da altra (o sconosciuta) sostanza - con disturbo da uso moderato o grave"
  ],
  "F19.281": [
    "Disfunzione sessuale indotta da altra (o sconosciuta) sostanza - con disturbo da uso moderato o grave"
  ],
  "F19.288": [
    "Disturbo ossessivo-compulsivo e disturbi correlati indotti da altra (o sconosciuta) sostanza - con disturbo da uso moderato o grave",
    "Disturbo neurocognitivo lieve indotto da altra (o sconosciuta) sostanza - con disturbo da uso moderato o grave"
  ],
  "F19.930": [
    "Astinenza da altra (o sconosciuta) sostanza - senza alterazioni percettive -  senza disturbo da uso"
  ],
  "F19.932": [
    "Astinenza da altra (o sconosciuta) sostanza - con alterazioni percettive - senza disturbo da uso"
  ],
  "F19.94": [
    "Disturbo bipolare e disturbi correlati indotti da altra (o sconosciuta) sostanza - senza disturbo da uso",
    "Disturbo depressivo indotto da altra (o sconosciuta) sostanza - senza disturbo da uso"
  ],
  "F19.959": [
    "Disturbo psicotico indotto da altra (o sconosciuta) sostanza - senza disturbo da uso"
  ],
  "F19.97": [
    "Disturbo neurocognitivo maggiore indotto da altra (o sconosciuta) sostanza - senza disturbo da uso"
  ],
  "F19.980": [
    "Disturbo d'ansia indotto da altra (o sconosciuta) sostanza - senza disturbo da uso"
  ],
  "F19.981": [
    "Disfunzione sessuale indotta da altra (o sconosciuta) sostanza - senza disturbo da uso"
  ],
  "F19.988": [
    "Disturbo ossessivo-compulsivo e disturbi correlati indotti da altra (o sconosciuta) sostanza - senza disturbo da uso",
    "Disturbo neurocognitivo lieve indotto da altra (o sconosciuta) sostanza - senza disturbo da uso"
  ],
  "F20.81": ["Disturbo schizofreniforme"],
  "F20.9": ["Schizofrenia"],
  "F21": ["Disturbo schizotipico di personalità"],
  "F22": ["Disturbo delirante"],
  "F23": ["Disturbo psicotico breve"],
  "F25.0": ["Disturbo schizoaffettivo - Tipo bipolare"],
  "F25.1": ["Disturbo schizoaffettivo - Tipo depressivo"],
  "F28": [
    "Disturbo dello spettro della schizofrenia e altri disturbi - con altra specificaizone"
  ],
  "F29": [
    "Disturbo dello spettro della schizofrenia e altri disturbi - senza specificazione"
  ],
  "F31.0": [
    "Disturbo bipolare I - attuale o più recente episodio ipomaniacale"
  ],
  "F31.11": [
    "Disturbo bipolare I - attuale o più recente episodio maniacale - lieve"
  ],
  "F31.12": [
    "Disturbo bipolare I - attuale o più recente episodio maniacale - moderato"
  ],
  "F31.13": [
    "Disturbo bipolare I - attuale o più recente episodio maniacale - grave"
  ],
  "F31.2": [
    "Disturbo bipolare I - attuale o più recente episodio maniacale - con caratteristiche psicotiche"
  ],
  "F31.31": [
    "Disturbo bipolare I - attuale o più recente episodio depressivo - lieve"
  ],
  "F31.32": [
    "Disturbo bipolare I - attuale o più recente episodio depressivo - moderato"
  ],
  "F31.4": [
    "Disturbo bipolare I - attuale o più recente episodio depressivo - grave"
  ],
  "F31.5": [
    "Disturbo bipolare I - attuale o più recente episodio depressivo - con caratteristiche psicotiche"
  ],
  "F31.71": [
    "Disturbo bipolare I - attuale o più recente episodio ipomaniacale - in remissione parziale"
  ],
  "F31.72": [
    "Disturbo bipolare I - attuale o più recente episodio ipomaniacale - in remissione completa"
  ],
  "F31.73": [
    "Disturbo bipolare I - attuale o più recente episodio maniacale - in remissione parziale"
  ],
  "F31.74": [
    "Disturbo bipolare I - attuale o più recente episodio maniacale - in remissione completa"
  ],
  "F31.75": [
    "Disturbo bipolare I - attuale o più recente episodio depressivo - in remissione parziale"
  ],
  "F31.76": [
    "Disturbo bipolare I - attuale o più recente episodio depressivo - in remissione completa"
  ],
  "F31.81": ["Disturbo bipolare II"],
  "F31.89": ["Disturbo bipolare e disturbi correlati con altra specificazione"],
  "F31.9": [
    "Disturbo bipolare I - attuale o più recente episodio depressivo - non specificato",
    "Disturbo bipolare I - attuale o più recente episodio ipomaniacale - non specificato",
    "Disturbo bipolare I - attuale o più recente episodio maniacale - non specificato",
    "Disturbo bipolare I - attuale o più recente episodio non specificato"
  ],
  "F32.81": ["Disturbo disforico premestruale"],
  "F32.89": ["Disturbo depressivo con altra specificazione"],
  "F32.A": ["Disturbo depressivo senza specificazione"],
  "F33.2": ["Disturbo depressivo maggiore - Episodio ricorrente - Grave"],
  "F33.3": [
    "Disturbo depressivo maggiore - Episodio ricorrente - con caratteristiche psicotiche"
  ],
  "F33.42": [
    "Disturbo depressivo maggiore - Episodio ricorrente - In remissione completa"
  ],
  "F34.0": ["Disturbo ciclotimico"],
  "F34.1": ["Disturbo depressivo persisitente"],
  "F34.81": ["Disturbo da disregolazione dell'umore dirompente"],
  "F39": ["Disturbo dell'umore non specificato"],
  "F40.00": ["Agorafobia"],
  "F40.10": ["Disturbo d'ansia sociale"],
  "F40.218": ["Fobia specifica - animale"],
  "F40.228": ["Fobia specifica - ambiente naturale"],
  "F40.230": ["Fobia specifica - paura del sangue"],
  "F40.231": ["Fobia specifica - paura delle iniezioni e trasfusioni"],
  "F40.232": ["Fobia specifica - paura di altre cure mediche"],
  "F40.233": ["Fobia specifica - paura delle ferite"],
  "F40.248": ["Fobia specifica - situazionale"],
  "F40.298": ["Fobia specifica - altro"],
  "F41.0": ["Disturbo di panico"],
  "F41.1": ["Disturbo d'ansia generalizzata"],
  "F41.8": ["Disturbo d'ansia con altra specificazione"],
  "F41.9": ["Disturbo d'ansia senza specificazione"],
  "F42.2": ["Disturbo ossessivo-compulsivo"],
  "F42.3": ["Disturbo da accumulo"],
  "F42.4": ["Disturbo da escoriazione (Stuzzicamento della pelle)"],
  "F42.8": [
    "Disturbo ossessivo-compulsivo e disturbi correlati con altra specifcazione"
  ],
  "F42.9": [
    "Disturbo ossessivo-compulsivo e disturbi correlati senza specificazione"
  ],
  "F43.0": ["Disturbo da stress acuto"],
  "F43.10": ["Disturbo da stress post-traumatico"],
  "F43.20": ["Disturbi dell'adattamento - non specificati"],
  "F43.21": ["Disturbi dell'adattamento - con umore depresso"],
  "F43.22": ["Disturbi dell'adattamento - con ansia"],
  "F43.23": ["Disturbi dell'adattamento - con ansia e umore depresso"],
  "F43.24": ["Disturbi dell'adattamento - con alterazione della condotta"],
  "F43.25": [
    "Disturbi dell'adattamento - con alterazione mista dell'emotività e della condotta"
  ],
  "F43.81": ["Disturbo da lutto prolungato"],
  "F43.89": [
    "Disturbo correlato a eventi traumatici e stressanti - con altra specificazione"
  ],
  "F43.9": [
    "Disturbo correlato a eventi traumatici e stressanti - senza specificazione"
  ],
  "F44.0": ["Amnesia dissociativa"],
  "F44.1": ["Amensia dissociativa, con fuga dissociativa"],
  "F44.6": [
    "Disturbo da sintomi neurologici funzionali (Disturbo di conversione) - Con anestesia o perdita di sensibilità"
  ],
  "F44.81": ["Disturbo dissociativo dell'identità"],
  "F44.89": ["Disturbo dissociativo con altra specificazione"],
  "F44.9": ["Disturbo dissociativo senza specificazione"],
  "F45.1": ["Disturbo da sintomi somatici"],
  "F45.21": ["Disturbo da ansia di malattia"],
  "F45.22": ["Disturbo da dismorfismo corporeo"],
  "F45.8": [
    "Disturbo da sintomi somatici e disturbi correlati - con altra specificazione"
  ],
  "F45.9": [
    "Disturbo da sintomi somatici e disturbi correlati - senza specificazione"
  ],
  "F48.1": ["Dsiturbo di depersonalizzazione/derealizzazione"],
  "F50.01": ["Anoressia nervosa - tipo abbuffante/condotte di eliminazione"],
  "F50.02": ["Anoressia nervosa - tipo con restrizioni"],
  "F50.2": ["Bulimia nervosa"],
  "F50.81": ["Disturbo da binge-eating"],
  "F50.82": ["Disturbo evitante/restrittivo dell'assunzione di cibo"],
  "F50.89": [
    "Disturbo della nutrizione o dell'alimentazione - con altra specificazione",
    "Pica - negli adulti"
  ],
  "F50.9": [
    "Disturbo della nutrizione o dell'alimentazione - senza specificazione"
  ],
  "F51.01": ["Disturbo da insonnia"],
  "F51.11": ["Disturbo da ipersonnolenza"],
  "F51.5": ["Disturbo da incubi"],
  "F52.0": ["Disturbo del desiderio sessuale - ipoattivo maschile"],
  "F52.21": ["Disturbo erettile"],
  "F52.22": [
    "Disturbo del desiderio sessuale - e dell'eccitazione sessuale femminile"
  ],
  "F52.31": ["Disturbo dell'orgasmo femminile"],
  "F52.32": ["Eiaculazione ritardata"],
  "F52.4": ["Eiaculazione precoce"],
  "F52.6": ["Disturbo del dolore genito-pelvico e della penetrazione"],
  "F52.8": ["Disfunzione sessuale con altra specificazione"],
  "F52.9": ["Disfunzione sessuale senza specificazione"],
  "F60.0": ["Disturbo paranoide di personalità"],
  "F60.1": ["Disturbo schizoide di personalità"],
  "F60.2": ["Disturbo antisociale di pesonalità"],
  "F60.3": ["Disturbo borderline di personalità"],
  "F60.4": ["Disturbo istrionico di personalità"],
  "F60.5": ["Disturbo ossessivo-compulsivo di personalità"],
  "F60.6": ["Disturbo evitante di personalità"],
  "F60.7": ["Disturbo dipendente di personalità"],
  "F60.81": ["Disturbo narcisistico di personalità"],
  "F60.89": ["Disturbo di personalità - con altra specificazione"],
  "F60.9": ["Disturbo di personalità - specificazione"],
  "F63.0": ["Disturbo da gioco d'azzardo"],
  "F63.1": ["Piromania"],
  "F63.2": ["Cleptomania"],
  "F63.3": ["Tricotillomania"],
  "F63.81": ["Disturbo esplosivo intermittente"],
  "F64.0": ["Disforia di genere - negli adolescenti e negli adulti"],
  "F64.2": ["Disforia di genere - nei bambini"],
  "F64.8": ["Disforia di genere - con altra specificazione"],
  "F64.9": ["Disforia di genere - senza specificazione"],
  "F65.0": ["Disturbo feticistico"],
  "F65.1": ["Disturbo da travestitismo"],
  "F65.2": ["Disturbo esibizionistico"],
  "F65.3": ["Disturbo voyeuristico"],
  "F65.4": ["Disturbo pedofilico"],
  "F65.51": ["Disturbo da masochismo sessuale"],
  "F65.52": ["Disturbo da sadismo sessuale"],
  "F65.81": ["Disturbo frotteuristico"],
  "F65.89": ["Disturbo parafilico - con altra specificazione"],
  "F65.9": ["Disturbo parafilico - senza specificazione"],
  "F68.10": ["Disturbo fittizio - provocato a sé"],
  "F68.A": ["Disturbo fittizio - provocato ad altri"],
  "F70": [
    "Disturbo dello sviluppo intellettivo (Disabilità intellettiva) - Lieve"
  ],
  "F71": [
    "Disturbo dello sviluppo intellettivo (Disabilità intellettiva) - Moderata"
  ],
  "F72": [
    "Disturbo dello sviluppo intellettivo (Disabilità intellettiva) - Grave"
  ],
  "F73": [
    "Disturbo dello sviluppo intellettivo (Disabilità intellettiva) - Estrema"
  ],
  "F79": [
    "Disturbo dello sviluppo intellettivo (Disabilità intellettiva) - senza specificazione"
  ],
  "F80.0": ["Disturbo fonetico-fonologico"],
  "F80.2": ["Disturbo del linguaggio"],
  "F80.81": ["Disturbo della fluenza - con esordio nell'infanzia (balbuzie)"],
  "F80.82": ["Disturbo della comunicazione - sociale (pragmatica)"],
  "F80.9": ["Disturbo della comunicazione - senza specificazione"],
  "F81.0": [
    "Disturbo specifico dell'apprendimento - Con compromissione della lettura"
  ],
  "F81.2": [
    "Disturbo specifico dell'apprendimento - Con compromissione del calcolo"
  ],
  "F81.81": [
    "Disturbo specifico dell'apprendimento - Con compromissione dell'espressione scritta"
  ],
  "F82": ["Disturbo dello sviluppo della coordinazione"],
  "F84.0": ["Disturbo dello spettro dell'autismo"],
  "F88": ["Disturbo del neurosviluppo - con altra specificazione"],
  "F89": ["Disturbo del neurosviluppo - senza specificazione"],
  "F90.0": [
    "Disturbo da deficit di attenzione/iperattività - Manifestazione con disattenzione predominante"
  ],
  "F90.1": [
    "Disturbo da deficit di attenzione/iperattività - Manifestazione con iperattività/impulsività predominanti"
  ],
  "F90.2": [
    "Disturbo da deficit di attenzione/iperattività - Manifestazione combinata"
  ],
  "F90.8": [
    "Disturbo da deficit di attenzione/iperattività - con altra specificazione"
  ],
  "F90.9": [
    "Disturbo da deficit di attenzione/iperattività - senza specificazione"
  ],
  "F91.1": ["Disturbo della condotta - tipo con esordio nell'infanzia"],
  "F91.2": ["Disturbo della condotta - tipo con esordio nell'adolescenza"],
  "F91.3": ["Dsiturbo oppositivo provocatorio"],
  "F91.8": [
    "Disturbo da comportamento dirompente, del controllo degli impulsi e della condotta - con altra specificazione"
  ],
  "F91.9": [
    "Disturbo da comportamento dirompente, del controllo degli impulsi e della condotta - senza specificazione",
    "Disturbo della condotta - esordio non specificato"
  ],
  "F93.0": ["Disturbo d'ansia da separazione"],
  "F94.1": ["Disturbo reattivo dell'attaccamento"],
  "F94.2": ["Disturbo da interazione sociale disinibita"],
  "F95.0": ["Disturbo transitorio da tic"],
  "F95.1": ["Disturbo persistente (cronico) da tic motori e vocali"],
  "F95.2": ["Disturbo di Tourette"],
  "F95.8": ["Disturbo da tic - con altra specificazione"],
  "F95.9": ["Disturbo da tic - senza specificazione"],
  "F98.21": ["Disturbo da ruminazione"],
  "F98.3": ["Pica - nei bambini"],
  "F98.4": ["Disturbo da movimento stereotipato"],
  "F98.5": ["Disturbo della fluenza - con esordio nell'età adulta"],
  "F99": [
    "Disturbo mentale con altra specificazione",
    "Disturbo mentale senza specificazione"
  ],
  "G25.81": ["Sindrome delle gambe senza riposo"],
  "G31.84": [
    "Disturbo neurocognitivo lieve a possibili corpi di Lewy",
    "Disturbo neurocognitivo lieve dovuto a eziologia sconosciuta",
    "Disturbo neurocognitivo lieve dovuto a possibile degenerazione frontotemporale",
    "Disturbo neurocognitivo lieve dovuto a possibile malattia di Alzheimer",
    "Disturbo neurocognitivo lieve possibilmente dovuto a malattia di Parkinson",
    "Disturbo neurocognitivo lieve possibilmente dovuto a malattia vascolare"
  ],
  "G47.00": ["Disturbo da insonnia - senza specificazione"],
  "G47.09": ["Disturbo da insonnia - altra specificazione"],
  "G47.10": ["Disturbo da ipersonnolenza - senza specificazione"],
  "G47.19": ["Disturbo da ipersonnolenza - con altra specificazione"],
  "G47.20": [
    "Disturbi circadiani del ritmo sonno-veglia - tipo non specificato"
  ],
  "G47.21": [
    "Disturbi circadiani del ritmo sonno-veglia - tipo fase di sonno ritardata"
  ],
  "G47.22": [
    "Disturbi circadiani del ritmo sonno-veglia - tipo fase di sonno anticipata"
  ],
  "G47.23": [
    "Disturbi circadiani del ritmo sonno-veglia - tipo ritmo sonno-veglia irregolare"
  ],
  "G47.24": [
    "Disturbi circadiani del ritmo sonno-veglia - tipo ritmo sonno-veglia diverso dalle 24 ore"
  ],
  "G47.26": [
    "Disturbi circadiani del ritmo sonno-veglia - tipo lavoro con turni"
  ],
  "G47.8": ["Disturbo del sonno-veglia - con altra specificazione"],
  "G47.9": ["Disturbo del sonno-veglia - senza specificazione"],
  "N39.498": [
    "Disturbo dell'evacuazione con altra specificazione - con sintomi urinari"
  ],
  "R15.9": [
    "Disturbo dell'evacuazione con altra specificazione - con sintomi fecali",
    "Disturbo dell'evacuazione senza specificazione - con sintomi fecali"
  ],
  "R32": [
    "Disturbo dell'evacuazione senza specificazione - con sintomi urinari"
  ],
  "R41.81": ["Declino cognitivo correlato all'età"],
  "R41.9": ["Disturbo neurocognitivo senza specificazione"],
  "R45.88": ["Autolesionismo non suicidario attuale"],
  "T14.91XA": ["Comportamento suicidario attuale - primo intervento"],
  "T14.91XD": ["Comportamento sucidario attuale - interventi successivi"],
  "Z72.0": ["Disturbo da uso di tabacco - lieve"],
  "Z76.5": ["Simulazione di malattia"],
  "Z91.51": ["Storia di comportamento suicidario"],
  "Z91.52": ["Storia di autolesionismo non suicidario"]
}
